import React from 'react';
import ReactDOM from 'react-dom';
import '@ifeng/container_content/common/client/commoncss/resetPC.css';
import Layout from './layout';

/* eslint-disable no-undef */
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable no-undef */
